"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeValidatedHttpClient = void 0;
const HttpClient_1 = require("./HttpClient");
const validation_1 = require("@fmtk/validation");
const trace_1 = require("./trace");
function makeValidatedHttpClient(base, middleware) {
    const client = middleware ? (0, HttpClient_1.makeHttpClient)(base, middleware) : base;
    return async (request, validateResult, validateRequest) => {
        let body = request.body;
        if (validateRequest) {
            const reqValidation = validateRequest({
                value: body,
                mode: validation_1.ValidationMode.Strict,
                extraFields: validation_1.ExtraFieldsMode.Ignore,
            });
            if (!reqValidation.ok) {
                (0, trace_1.trace)({ msg: `request validation failure`, err: reqValidation.errors });
                throw new validation_1.ModelValidationError(reqValidation.errors);
            }
            body = reqValidation.value;
        }
        const response = await client({ ...request, body });
        if (!response.body || !validateResult) {
            return response;
        }
        const resValidation = validateResult({
            value: response.body,
            mode: validation_1.ValidationMode.JSON,
            extraFields: validation_1.ExtraFieldsMode.Ignore,
        });
        if (!resValidation.ok) {
            (0, trace_1.trace)({ msg: `response validation failure`, err: resValidation.errors });
            throw new validation_1.ModelValidationError(resValidation.errors);
        }
        return {
            ...response,
            body: resValidation.value,
        };
    };
}
exports.makeValidatedHttpClient = makeValidatedHttpClient;
//# sourceMappingURL=ValidatedHttpClient.js.map